export default theme => ({
  centeredImage: {
    display: "block",
    margin: "auto",
  },
});
